(() => {
  // RideOn: i tab sono link a pagine reali (vedi content-tabs.liquid). Resta solo l'accordion.
  const initCollapsibleBlock = (section) => {
    if (!section || !section.classList.contains("content-tabs-section")) return;
    const blocks = section.querySelectorAll(".content-tabs__collapsible");

    blocks.forEach((block) => {
      block.addEventListener("click", (event) => {
        const toggleEl = event.target.closest(
          ".content-tabs__collapsible-toggle"
        );
        if (!toggleEl) return;

        const contentEl = toggleEl.nextElementSibling;
        if (
          !contentEl ||
          !contentEl.classList.contains("content-tabs__collapsible-content")
        ) {
          return;
        }

        const isActive = toggleEl.classList.contains("active");
        if (!isActive) {
          slideDown(toggleEl, contentEl, 300); // func in global.js
        } else {
          slideUp(toggleEl, contentEl, 300); // func in global.js
        }
      });
    });
  };

  initCollapsibleBlock(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initCollapsibleBlock(event.target);
  });
})();
